import React from 'react';
import { View, Text, StyleSheet, Alert } from 'react-native';

export interface HelloWorldProps {
  name?: string;
  color?: string;
}

export const HelloWorldWeb: React.FC<HelloWorldProps> = ({ 
  name = 'World', 
  color = '#007AFF' 
}) => {
  // Add some debuggable logic
  const currentTime = new Date().toLocaleTimeString();
  const greeting = `Hello, ${name}!`;
  
  // This is where you can set breakpoints
  console.log('HelloWorldWeb rendering with props:', { name, color });
  
  const handlePress = () => {
    debugger; // This will force a breakpoint
    
    // Enhanced debugging info
    console.log('=== HelloWorldWeb Debug Info ===');
    console.log('Button pressed at:', currentTime);
    console.log('Props:', { name, color });
    console.log('Greeting:', greeting);
    console.log('Component state at press time:', {
      timestamp: new Date().toISOString(),
      component: 'HelloWorldWeb',
      action: 'handlePress'
    });
    console.log('===============================');
    
    Alert.alert('Debug Info', `${greeting} at ${currentTime}`);
  };

  return (
    <View style={styles.container}>
      <Text style={{...styles.text, color}} onPress={handlePress}>
        {greeting} 🚀
      </Text>
      <Text style={styles.subtitle}>
        This component is from @child-nav/shared (Web Version)
      </Text>
      <Text style={styles.debugText}>
        Tap the greeting to debug! Time: {currentTime}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 20,
    alignItems: 'center',
    backgroundColor: '#f0f0f0',
    borderRadius: 10,
    margin: 10,
    display: 'flex',
    flexDirection: 'column',
  },
  text: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 5,
  },
  subtitle: {
    fontSize: 14,
    color: '#666',
    fontStyle: 'italic',
  },
  debugText: {
    fontSize: 12,
    color: '#999',
    marginTop: 10,
    textAlign: 'center',
  },
});